import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button } from '@origo/origo-ui';
import type { DispensasjonFormValues, FieldChangeHandler } from '../../../types';
import DispensationForm, { type DispensationFieldErrors } from './DispensationForm';

interface NewDispensationDialogProps {
    open: boolean;
    values: DispensasjonFormValues;
    fieldErrors: DispensationFieldErrors;
    onChange: FieldChangeHandler<DispensasjonFormValues>;
    onClose: () => void;
    onSave: () => void;
    isSaving?: boolean;
}

/** Opprett ny dispensasjon (jf. spec F12.3). Native <dialog> via origo-ui Dialog. */
const NewDispensationDialog: React.FC<NewDispensationDialogProps> = ({
    open,
    values,
    fieldErrors,
    onChange,
    onClose,
    onSave,
    isSaving = false,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={() => {
                if (!isSaving) onClose();
            }}
            title={t('dispensations.new.title')}
            footer={
                <>
                    <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="primary" onClick={onSave} disabled={isSaving}>
                        {t('dispensations.new.submit')}
                    </Button>
                </>
            }
        >
            <DispensationForm values={values} fieldErrors={fieldErrors} onChange={onChange} />
        </Dialog>
    );
};

export default NewDispensationDialog;
